import { isEmpty } from "lodash-es";
import { useIntl } from "react-intl";
import type { InfinitySelectOption } from "~components/InfinitySelect";
import { SelectSeasonEntity } from "~components/SelectSeasonEntity/SelectSeasonEntity";
import { ImageTypes } from "~enums/imageTypes";
import type { Entity } from "~types/entity";
import { useUpdateListFixture } from "../../hooks";
import type { ColumnComponentProperties } from "../../types";
import { StyledCompetitorCell } from "./Columns.styles";

type Props = ColumnComponentProperties & {
  entity: Entity;
  isHome: boolean;
  oppositeEntity: Entity;
};

export const EntityColumn = ({ entity, isHome, oppositeEntity, editMode, fixtureId }: Props) => {
  const { formatMessage } = useIntl();
  const { mutate: updateFixture, isPending: isLoading } = useUpdateListFixture();

  if (editMode) {
    const value = isEmpty(entity) ? null : { label: entity.nameFullLocal, value: entity.entityId };

    const onChangeHandler = (competitorOption: InfinitySelectOption | null) => {
      const competitors: {
        isHome: boolean;
        entityId: string;
      }[] = [];
      if (!isEmpty(competitorOption) && !isEmpty(competitorOption.value)) {
        competitors.push({ entityId: competitorOption.value, isHome });
      }
      if (!isEmpty(oppositeEntity?.entityId)) {
        competitors.push({
          entityId: oppositeEntity.entityId,
          isHome: !isHome,
        });
      }

      updateFixture({
        fixtureId,
        upsertData: {
          competitors: competitors,
        },
      });
    };

    return (
      <SelectSeasonEntity
        disabled={isLoading}
        placeholder={formatMessage({
          id: `fixtureListPage.table.column.editMode.${isHome ? "homeCompetitor" : "awayCompetitor"}.placeholder`,
        })}
        value={value}
        disabledOptionValues={isEmpty(oppositeEntity?.entityId) ? [] : [oppositeEntity.entityId]}
        onChange={onChangeHandler}
        rightAligned={isHome}
      />
    );
  }

  const entityLogoUrl =
    entity?.images?.filter((x) => x.imageType === ImageTypes.Logo)?.[0]?.url ||
    entity?.images?.filter((x) => x.imageType === ImageTypes.LogoAlternate)?.[0]?.url;

  return (
    <StyledCompetitorCell $isReverse={isHome}>
      {entity &&
        (entityLogoUrl ? (
          <img alt="Team logo" src={entityLogoUrl} width={25} height={25} />
        ) : (
          <i style={{ width: 25 }} className="fas fa-shield fa-xl" />
        ))}
      <span>{entity?.nameFullLocal}</span>
    </StyledCompetitorCell>
  );
};
